import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {
	sidebar: false,
	permission:null
}

export const sidebarSlice = createSlice({
	name: "sidebar",
	initialState,
	reducers: {
		setSidebar: (state, action: PayloadAction<any>) => {
			state.sidebar = action.payload.status;
		},
		setPermission: (state, action: PayloadAction<any>) => {
			state.permission = action.payload.permission;
		}
	}
})

export const {
	setSidebar,
	setPermission
} = sidebarSlice.actions

export default sidebarSlice.reducer